import React from 'react';
import styles from './PWAInstallMessage.module.scss';
import { Link, Typography, useTheme } from '@material-ui/core';
import JetFontIcon, { JET_FONTICON_ALIASES } from '../JetFontIcon';
import utilStorage from '@src/shared/services/util-storage';
import { useTranslation } from 'react-i18next';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';

export const PWAInstallMessage = ({ onCTA = () => {}, onClose = () => {} }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const handleClose = () => {
    utilStorage.increasePWATutorialCounter();
    utilStorage.setPWATutorialPostpone(PWA_TUTORIAL.EXPIRE_IN_MINUTES);
    onClose();
  };

  const { isIOS } = useDeviceDetect();

  return (
    <div className={`${styles.messageBanner} ${isIOS ? styles.IOS : ''}`}>
      <div className={styles.messageBannerLeft}>
        <JetFontIcon
          color={theme.palette.jet?.supportInfo}
          size={16}
          iconname={JET_FONTICON_ALIASES.INFO_MARKER}
        />
      </div>
      <div className={styles.messageBannerContent}>
        <Typography variant="body1" className="body_bold">
          {t('pwa_installation_screen.top_message_title')}
        </Typography>
        <Typography variant="body1" className="body_small_regular">
          {t('pwa_installation_screen.top_message_content')}
          <Link
            color="inherit"
            underline="always"
            onClick={() => {
              utilStorage.clearPWATutorialStatus();
              onCTA();
            }}
          >
            {t('pwa_installation_screen.top_message_cta_content')}
          </Link>
          .
        </Typography>
      </div>
      <div className={styles.messageBannerRight}>
        <JetFontIcon onClick={handleClose} iconname={JET_FONTICON_ALIASES.CLOSE} />
      </div>
    </div>
  );
};

export default PWAInstallMessage;
